/* If the shipping threshold metaobject exists, it will replace the default or the market's metafields displayed in the announcement */

// Helper function to poll for an element's availability
function pollForElement(selector, callback, timeout = 10000, interval = 100) {
  const startTime = Date.now();

  function check() {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
      return;
    }

    if (Date.now() - startTime < timeout) {
      setTimeout(check, interval);
    } else {
      console.warn(`Element ${selector} not found after ${timeout}ms timeout`);
    }
  }

  check();
}

function updateRebuyShippingThreshold(event) {
  const rebuyCart = document.querySelector('#rebuy-cart');
  const shopCurrencyActive = Shopify.currency.active;
  const shippingThresholdElement = document.querySelector('#shipping-thresholds');
  const shippingThresholdObject = JSON.parse(shippingThresholdElement.innerHTML);
  const freeShippingTexts = document.querySelectorAll('.shipping-threshold_value');

  const freeShippingText = document.querySelector('.js-freeshipping-text');
  const rebuyText = document.querySelector('.free-shipping_announcement');

  if (rebuyCart) {
    if (!rebuyText) {
      // Poll for the rebuyText element instead of returning early
      pollForElement('.free-shipping_announcement', (element) => {
        element.innerHTML = freeShippingText.innerHTML;
      });
      return;
    }
    rebuyText.innerHTML = freeShippingText.innerHTML;
  }

  // Update all threshold html elements if the store's active currency matches one from the object
  Object.entries(shippingThresholdObject).forEach(([currencyCode, currencyObject]) => {
    if (shopCurrencyActive === currencyCode) {
      freeShippingTexts.forEach((element) => {
        element.innerHTML = `${Math.trunc(currencyObject.threshold)} ${currencyObject.currency}`;
      });
    }
  });
}

document.addEventListener('rebuy:cart.change', (event) => {
  updateRebuyShippingThreshold(event);
});

document.addEventListener('rebuy:cart.ready', (event) => {
  updateRebuyShippingThreshold(event);
});
